export const RootNavigation = 'RootNavigation';
export const AnyNavigation = "AnyNavigation";
export const WelcomeNavigation = "WelcomeNavigation";
export const MedicalReportsNavigation = 'MedicalReportsNavigation';
export const HealthRecordsNavigation = 'HealthRecordsNavigation';
export const LoginNavigation = "LoginNavigation";
export const PrivacyPolicyNavigation = "PrivacyPolicyNavigation"
export const TermsConditionsNavigation = "TermsConditionsNavigation"
export const InformationProtectionNavigation = "InformationProtectionNavigation"
export const ProviderNavigation = "ProviderNavigation";
export const ProvidersNavigation = "ProvidersNavigation";
export const WatchNavigation = "WatchNavigation";
export const VaccinationNavigation = "VaccinationNavigation";
export const AllergyNavigation = "AllergyNavigation";
export const UserProfileNavigation = "UserProfileNavigation";
export const ChangePasswordNavigation = "ChangePasswordNavigation";
export const UserContactNavigation = "UserContactNavigation";
export const UserDevicesNavigation = "UserDevicesNavigation"
export const ReportsNavigation = "ReportsNavigation";
export const ReportNavigation = "ReportNavigation";
export const ProceduresNavigation = "ProceduresNavigation";
export const LabsNavigation = "LabsNavigation";
export const PdfsNavigation = "PdfsNavigation";
export const PdfNavigation = "PdfNavigation";
export const CdasNavigation = "CdasNavigation";
export const CdaNavigation = "CdaNavigation";
export const MedicationsNavigation = "MedicationsNavigation";
export const DiagnosisNavigation = "DiagnosisNavigation";
export const RegisterNavigation = "RegisterNavigation";
export const AdminRegisterNavigation = "AdminRegisterNavigation";
export const PageNotFoundNavigation = "PageNotFoundNavigation";
export const SearchPageNavigation = "SearchPageNavigation";
export const ResumeFsm = "ResumeFsm";
export const NoResumeFsm = "NoResumeFsm";
export const LoggingIn = "LoggingIn";
export const LoggedIn = "LoggedIn";
export const LoginFailure = "LoginFailure";
export const Logout = "Logout";
export const LogoutRequest = "LogoutRequest";
export const Activate = "Activate";
export const Deactivate = "Deactivate";
export const RequestSaveFsm = "RequestSaveFsm";
export const SaveFsm = "SaveFsm";
export const FsmLoad = "FsmLoaded";
export const FsmStart = "FsmStart";
export const SessionTimeout = "SessionTimeout";
export const RegistrationFailure = "RegistrationFailure"
export const RegistrationSuccess = "RegistrationSuccess";
export const RequestRegistration = "RequestRegistration";
export const Continue = "Continue";
export const RequestPasswordResetNavigation = "RequestPasswordResetNavigation";
export const PasswordResetNavigation = "PasswordResetNavigation";
export const ConfirmRegistrationNavigation = "ConfirmRegistrationNavigation";
export const ConfirmPasswordResetNavigation = "ConfirmPasswordResetNavigation";
export const DataUploadNavigation = 'DataUploadNavigation';
export const VitalsNavigation = 'VitalsNavigation'
export const DirectivesNavigation = 'DirectivesNavigation'
export const VitalsGroup = 'VitalsGroup'
export const NotesNavigation = 'NotesNavigation'
export const ProfessionalNotesNavigation = 'ProfessionalNotesNavigation'
export const CurrentProcNavigation = 'CurrentProcNavigation'
export const CurrentDiagNavigation = 'CurrentDiagNavigation'
export const CurrentMedNavigation = 'CurrentMedNavigation'
export const CurrentProvNavigation = 'CurrentProviderNavigation'
export const CurrentNurseNavigation = 'CurrentNurseNavigation'
export const PatientNurseNavigation = 'PatientNurseNavigation'
export const MyAccountNavigation ='MyAccountNavigation'
export const OrdersNavigation = 'OrdersNavigation'
export const MedAdminNavigation = 'MedAdminNavigation'
export const CptBillingNavigation = 'CptBillingNavigation'
export const CptNavigation = 'CptNavigation'
export const VerifyNurseNavigation = 'VerifyNurseNavigation'
export const VerifyAccountNavigation = 'VerifyAccountNavigation'
export const VerifyProviderNavigation = 'VerifyProviderNavigation' // med-order / Add User provider invite
export const VerifyContactNavigation = 'VerifyContactNavigation'
export const sixDigitNavigation = 'sixDigitNavigation'
export const AllergyModuleNavigation = 'AllergyModule'
export const PatientCardNavigation ='PatientCardNavigation'
export const AlliedCardNavigation ='AlliedCardNavigation'
export const HomeHealthAidNavigation ='HomeHealthAidNavigation'
export const ProviderSchedulingNavigation ="ProviderSchedulingNavigation"
